const Footer: React.FC = () => {
    return (
        <div className="c-footer">
            <div className="mx-2">
                <div className="row">
                    <div className="col">
                        <strong>General Information</strong>
                        <div>
                            <a href="https://www.sartorius.com/en/imprint">
                                Imprint
                            </a>
                        </div>
                        <div>
                            <a href="https://download.dam.sartorius.com/d/asset/300533?download=false">
                                Digital Platforms Terms of Use
                            </a>
                        </div>
                        <div>
                            <a href="https://www.sartorius.com/en/general-terms-and-conditions">
                                Terms & Conditions
                            </a>
                        </div>
                        <div>
                            <a href="https://www.sartorius.com/en/data-protection">
                                Data Privacy Notice
                            </a>
                        </div>
                    </div>
                    <div className="mt-8">©2023 Sartorius AG</div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
